// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '@popperjs/core/dist/esm/popper';
import 'bootstrap/js/dist/tooltip';

const fragments = {
  TOOLTIP: '[data-fragment="Tooltips.tooltip"]',
};

export default class Tooltips extends WebComponent {
  didMount() {
    $(fragments.TOOLTIP).tooltip();
    // $(fragments.TOOLTIP).tooltip('show');
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tooltips.js